<template>
  <div>
    <h4 v-if="this.data.title">{{ this.data.title }}</h4>
    <ReportFilterBadge :metadata="this.data.metadata" />
    <table class="table table-striped table-bordered">
      <tbody>
        <tr>
          <th v-for="(header, index) in this.headers" :key="index">{{ header }}</th>
        </tr>
        <template v-for="(rows, group) in this.rowsByGroup">
          <tr v-for="(row, rowIndex) in rows" :key="group + '-' + rowIndex">
            <td v-if="rowIndex === 0 && group !== '__ungrouped__'" :rowspan="rows.length">{{ group }}</td>
            <td v-for="(cell, cellIndex) in row" :key="cellIndex">
              <span v-html="formatterByDataType[cell.dataType](cell.value)"></span>
            </td>
          </tr>
        </template>
        <template v-if="Object.keys(this.rowsByGroup).length === 0">
          <tr>
            <td :colspan="this.headers.length">Não há informações para este relatório no ano selecionado.</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
  import ReportFilterBadge from '@/components/elements/ReportFilterBadge'

  export default {
    name: 'TableReport',
    components: { ReportFilterBadge },
    props: ['data'],
    data () {
      return {
        formatterByDataType: {
          'text': function (value) {
            if (value === '') return '-'
            return value
          },
          'currency': function (value) {
            let formatter = Intl.NumberFormat('pt-BR', {minimumFractionDigits: 2})
            return formatter.format(value)
          },
          'percentage': function (value) {
            return Number(value).toFixed(2).replace('.', ',') + '%'
          },
          'integer': function (value) {
            return Number(value).toLocaleString('pt-BR')
          }
        }
      }
    },
    computed: {
      headers: function () {
        if (!this.data.report || !this.data.report.rows) return []

        const hasGroupedRows = this.data.report.rows.some(function (row) {
          return row.group !== undefined && row.group !== null && row.group !== ''
        })
        if (hasGroupedRows) {
          return [...[''], ...this.data.report.columns]
        }

        return [...this.data.report.columns]
      },
      rowsByGroup: function () {
        if (!this.data.report || !this.data.report.rows) return []

        const rowsByGroup = {}
        this.data.report.rows.forEach(function (row) {
          const groupKey = row.group !== undefined && row.group !== null && row.group !== ''
            ? row.group
            : '__ungrouped__'
          if (!rowsByGroup.hasOwnProperty(groupKey)) {
            rowsByGroup[groupKey] = []
          }
          rowsByGroup[groupKey].push(row.cells)
        })

        return rowsByGroup
      }
    }
  }
</script>

<style scoped>
  h4, table {
    color: #333;
  }
  th {
    text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// TableReport.vue?751c3c6f